var _jsxFileName = "/Users/kayote/Documents/ReactApps/fretboard-viz-tool/dependencies/react-fretboard/components/Fretboard/Skins/NutGraphicStrings/index.js";
import React from 'react';
import pt from 'prop-types';
import { stringCenter } from './../../../../lib/fretboard';

const NutGraphicStrings = ({
  nrOfStrings
}) => {
  const top = stringCenter(nrOfStrings)(0);
  const bottom = stringCenter(nrOfStrings)(nrOfStrings - 1) - top;
  return /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: `${top}%`,
    width: "100%",
    height: `${bottom}%`,
    fill: "black",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 5
    }
  });
};

NutGraphicStrings.propTypes = {
  nrOfStrings: pt.number.isRequired
};
export default NutGraphicStrings;
